let BrowserLocation = {
  localStorageKey: "@ndBrowserLocation",
  locationUrl: {
    current: null,
    next: null,
    key: null,
  },
  currentTarget: null,
  save: function (next = false) {
    let location = document.URL;
    if (!location.match(/(auth\/token)|\/login\//)) {
      let key = next ? "next" : "current";
      this.locationUrl.key = key;
      this.locationUrl[key] = location;
      this.storeLocation();
    }
  },
  restoreLocation() {
    let data = JSON.parse(localStorage.getItem(this.localStorageKey));
    if (data === null) return;
    this.locationUrl = data;
    let key = this.locationUrl.key;
    let url = this.locationUrl[key] || "";
    if (this.isNotHomeUrl(url)) window.location.href = url;
  },
  setTargetUrl(url) {
    this.locationUrl.key = "next";
    this.locationUrl.next = url;
    this.storeLocation();
  },
  storeLocation() {
    localStorage.setItem(
      this.localStorageKey,
      JSON.stringify(this.locationUrl)
    );
  },
  isNotHomeUrl(url) {
    let isUrl = url.match(/^https?:\/\//);
    let isNotHomeUrl = !(
      url.match(/^https:\/\/dashboard\.(.*)?ring\.com\/?$/) ||
      url.match(/^https:\/\/localhost:8080\/?$/)
    );
    return isUrl && isNotHomeUrl;
  },
};
export default Object.create(BrowserLocation);
